/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DocumentErrors model module.
 * @module model/DocumentErrors
 * @version 1.0.0
 */
class DocumentErrors {
    /**
     * Constructs a new <code>DocumentErrors</code>.
     * @alias module:model/DocumentErrors
     */
    constructor() { 
        
        DocumentErrors.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DocumentErrors</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DocumentErrors} obj Optional instance to populate.
     * @return {module:model/DocumentErrors} The populated <code>DocumentErrors</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DocumentErrors();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('custom_error_message')) {
                obj['custom_error_message'] = ApiClient.convertToType(data['custom_error_message'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
DocumentErrors.prototype['id'] = undefined;

/**
 * @member {String} custom_error_message
 */
DocumentErrors.prototype['custom_error_message'] = undefined;






export default DocumentErrors;

